import { useEffect } from "react";
import { ButtonV2, ContainerV2, H1, P, PaginationV2 } from "../../Atoms";
import { SchedulesFilterFormV2 } from "../../Molecules/SchedulesFilterFormV2";
import { ScheduleCardV2 } from "../../Molecules/ScheduleCardV2";
import { Tracking } from "../../../services/Tracking";
import { useSchedulesV2 } from "./useSchedulesV2";

export const SchedulesV2 = () => {
  const {
    isCliente,
    isFilterOpen,
    handleToggleFilter,
    handleFilter,
    handleClearFilter,
    handleNovoAgendamento,
    agendamentos,
    pagination,
    setNumberPage,
    atribuirAgendamento,
    iniciarVistoria,
  } = useSchedulesV2();

  useEffect(() => {
    Tracking.pageView("mapa:meus-agendamentos:pageview");
  }, []);

  return (
    <ContainerV2>
      <H1 className="mb-8">
        {isCliente ? "Meus Agendamentos" : "Agendamentos"}
      </H1>

      <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
        <div>
          {!isFilterOpen && (
            <ButtonV2
              variant="outline"
              onClick={handleToggleFilter}
              className="rounded-[10px]"
            >
              <img src="/assets/svgs/icon-filter-dark.svg" alt="icone filtro" />
              Filtro
            </ButtonV2>
          )}
        </div>

        <ButtonV2 onClick={handleNovoAgendamento}>
          <img
            src="/assets/svgs/icon-add-white.svg"
            alt=""
            className="h-3.5 w-3.5"
          />
          Novo agendamento
        </ButtonV2>
      </div>

      {isFilterOpen && (
        <SchedulesFilterFormV2
          className="mb-6"
          isCliente={isCliente}
          onFilter={handleFilter}
          onClear={handleClearFilter}
        />
      )}

      <div className="flex flex-col gap-4">
        {agendamentos.length === 0 ? (
          <P className="text-center">Nenhum agendamento encontrado</P>
        ) : (
          agendamentos.map((item) => (
            <ScheduleCardV2
              key={item.uuid}
              agendamento={item}
              onAssignSchedule={atribuirAgendamento}
              onStartSchedule={iniciarVistoria}
            />
          ))
        )}
      </div>

      {agendamentos.length > 0 && (
        <PaginationV2
          className="mt-8"
          totalPage={pagination.totalPage}
          totalRegister={pagination.totalRegister}
          actualPage={pagination.actualPage}
          setNumberPage={setNumberPage}
        />
      )}
    </ContainerV2>
  );
};
